import Typography from '@mui/material/Typography';
import { styled } from '@mui/material/styles';
import { useTranslation } from 'react-i18next';
import { toLocaleDateTime } from 'src/common/utils/dateUtils';
import { useProductSummaryLastUpdate } from '../hooks/useProductSummaryLastUpdate';

const LastUpdateBoxTypography = styled(Typography)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'flex-end',
  padding: theme.spacing(0, 8),
  verticalAlign: 'bottom',
}));

export const ProductSummaryLastUpdate = () => {
  const { t } = useTranslation();
  const { data } = useProductSummaryLastUpdate();
  return data ? (
    <LastUpdateBoxTypography
      variant="text4"
      color="text.secondary"
      data-testid="productSummaryLastUpdate"
      alignSelf="center"
    >
      {`${t('productSummary.lastUpdated')}: ${toLocaleDateTime(data)}`}
    </LastUpdateBoxTypography>
  ) : null;
};
